const GET_DRIVER_INFO = "GET_DRIVER_INFO";
const GET_DRIVER_INFO_SUCCESS = "GET_DRIVER_INFO_SUCCESS";
const GET_DRIVER_INFO_FAILURE = "GET_DRIVER_INFO_FAILURE";
const CLEAR_GET_DRIVER_INFO = "CLEAR_GET_DRIVER_INFO";
const GetDriverInfoSymbols = {
  GET_DRIVER_INFO_SUCCESS,
  GET_DRIVER_INFO_FAILURE,
  GET_DRIVER_INFO,
  CLEAR_GET_DRIVER_INFO,
};
export default GetDriverInfoSymbols;
